// extracted by mini-css-extract-plugin
export default {"buttonPosition":"_7e7495acb625d454b54c826648bad6fc"};